import React from "react";
import { Button } from "../Button";
import { ButtonDecline } from "../ButtonDecline";
import { Content } from "./styles";

interface Props {
  title: string;
  description?: string;
  loading?: boolean;
  confirm: ()=> void;
  cancel: ()=> void;
}
export function ModalCofirm({ title,description, confirm, cancel,loading = false,...rest }: Props) {
  return(
    <Content
        visible={true}
        onCancel={cancel}
        closable={false}
        footer={[
          <div className="actions">
          <ButtonDecline title="Cancelar" onClick={cancel} disabled={loading}/>
          <Button title="Sim" onClick={confirm} loading={loading} />
          </div>
          
        ]}
        width="500px"
        maskStyle={{
          background: 'rgba(43, 43, 69, 0.8)'
        }}
      >
        <div className="title">
          {title}
        </div>
        <div className="description">
          {description}
        </div>
      </Content>
      
  )
}
